import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  BASE_URL_SANDBOX,
  GET_PRODUCT_CATEGORY_DISCOUNTS,
} from '../../../Constants/Config';

const initialState = {
  loading: false,
  productCategoryDiscounts: [],
  error: '',
};

export const fetchProductCategoryDiscounts = createAsyncThunk(
  'bogoList/fetchProductCategoryDiscounts',
  async (data) => {
    try {
      const response = await axios.post(
        BASE_URL_SANDBOX + GET_PRODUCT_CATEGORY_DISCOUNTS,
        data,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );

      if (
        response.status === 200 &&
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        return response.data.data;
      } else {
        return [];
      }
    } catch (e) {}
  },
);

const productCategoryDiscountSlice = createSlice({
  name: 'productCategoryDiscounts',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchProductCategoryDiscounts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchProductCategoryDiscounts.fulfilled,
      (state, action) => {
        state.loading = false;
        state.productCategoryDiscounts = action.payload || [];
        state.error = '';
      },
    );
    builder.addCase(fetchProductCategoryDiscounts.rejected, (state, action) => {
      state.loading = false;
      state.productCategoryDiscounts = [];
      state.error = action.error.message;
    });
  },
});

export default productCategoryDiscountSlice.reducer;
